export default {
  namespaced: true,

  state: () => ({
    seo: {},
  }),

  getters: {
    getSeo: (state) => state.seo,
  },

  mutations: {
    setSeo: (state, data) => {
      state.seo = data;
    },
  },

  actions: {
    async loadSeo({ commit }, { url }) {
      try {
        const seo = await this.$apiBFF.fetchSeo(url);

        const {
          title, description, canonical, h1, text,
        } = seo;

        commit('setSeo', {
          title, description, canonical, h1, text,
        });

        return seo;
      } catch (e) {
        commit('setSeo', {});
      }
    },
  },
};
